import React from "react";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import Cta from "@qlik/qlik/src/components/Cta";
import Media from "@qlik/qlik/src/components/Media";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import formatContentfulRichText from "@qlik/qlik/src/lib/format-rich-text-content";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import * as styles from "./styles.module.css";

const PageContent = ({ data }) => {
    const { additionalConfiguration, cardItems, backgroundColor, backgroundImage, customId } = data;
    const spacingClassName = getSpacingClassName(additionalConfiguration, "py-10 lg:py-30");
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    return (
        <section className={`${spacingClassName} page-content-section`} id={customId}>
            <div className="container rounded relative overflow-hidden lg-px-[150px]">
                <div
                    className={`card-wrapper grid gap-5 lg:gap-15 md:grid-cols-3 p-5 lg:p-7.5 rounded relative overflow-hidden ${sectionColorMapping.bgColor}`}
                >
                    {cardItems?.map((card) => (
                        <div className={`relative flex flex-col ${styles.cardItem} cardItem`}>
                            {card?.body && (
                                <div className={`${styles.cardbody} card-description pb-5`}>
                                    {renderRichText(card.body, formatContentfulRichText())}
                                </div>
                            )}
                            {card?.cta && (
                                <div className="card-cta mt-auto">
                                    {card.cta.map((button) => (
                                        <Cta key={button.id} data={button} className="tracking-normal mt-2.5 block" />
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                {backgroundImage?.[0] && (
                    <div className="background-img absolute right-10 sm:right-3.75 bottom-0">
                        <Media link={backgroundImage?.[0]?.secure_url} className="w-full max-w-[330px]" />
                    </div>
                )}
            </div>
        </section>
    );
};
export default PageContent;
